import request from '@/utils/request';

/**
 * 给 URL 加上时间戳查询参数，防止浏览器缓存
 */
function withTimestamp(url) {
  if (!url) return '';
  const clean = url.split('?')[0];
  return `${clean}?t=${Date.now()}`;
}

export default {
  namespaced: true,
  state: {
    // 控制菜单是否展开
    isExpend: JSON.parse(localStorage.getItem('VUE_APP_IsExpend')) !== null
      ? JSON.parse(localStorage.getItem('VUE_APP_IsExpend'))
      : true,
    // 系统 Logo URL（从 localStorage 恢复时也加时间戳，避免使用浏览器缓存的旧图片）
    logoUrl: withTimestamp(localStorage.getItem('VUE_APP_LOGO_URL') || ''),
  },
  mutations: {
    setIsExpend(state) {
      state.isExpend = !state.isExpend;
      localStorage.setItem('VUE_APP_IsExpend', JSON.stringify(state.isExpend));
    },
    /**
     * 更新 Logo URL
     * @param {string} url - 后端返回的 logo 路径（如 /uploads/system/logo.png），为空则清除
     */
    setLogoUrl(state, url) {
      if (url) {
        const cleanUrl = url.split('?')[0];
        state.logoUrl = `${cleanUrl}?t=${Date.now()}`;
        localStorage.setItem('VUE_APP_LOGO_URL', cleanUrl);
      } else {
        state.logoUrl = '';
        localStorage.removeItem('VUE_APP_LOGO_URL');
      }
    },
  },
  actions: {
    /**
     * 从后端加载系统 Logo 配置
     * 该接口为公开接口，登录前也可调用
     */
    async fetchLogo({ commit }) {
      try {
        const res = await request({ method: 'get', url: '/system/config/logo' });
        if (res && res.code === 200 && res.data?.url) {
          commit('setLogoUrl', res.data.url);
        }
      } catch {
        // 网络错误静默处理，使用内置默认 Logo
      }
    },
  },
};
